"use client";

import Image from "next/image";
import Link from "@/components/ui/Link";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';

type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};

type Props = {
  imageSrc?: FieldConfig;
  title?: FieldConfig;
  slug?: string;
  className?: string;
  imageMetadata?: ImageMetadata;
};

export default function ImageText({
  imageSrc = { hidden: false, value: FALLBACK_IMAGE, customClass: "" },
  title = { hidden: false, value: "ரஜினி - 75", customClass: "" },
  slug,
  className = "",
  imageMetadata,
}: Props) {
  const imageSrcValue = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;
  const titleValue = title?.value || "";
  const content = (
    <article
      className={`bg-white overflow-hidden border-2 border-012061 flex flex-col ${className}`}
      style={{ width: '228px', height: '377px' }}
    >
      {/* IMAGE CONTAINER WITH BORDER + PADDING */}
      {!imageSrc?.hidden && (
        <div className="relative flex-1">
          <div className={`border-b-4 border-012061 p-2 h-full ${imageSrc?.customClass || ""}`}>
            <div className="relative w-full h-full overflow-hidden">
              <Image
                src={imageSrcValue}
                alt={titleValue}
                fill
                className="object-cover"
                style={getFocusPointStyle(imageMetadata)}
                loading="lazy"
                sizes="228px"
                placeholder="blur"
                blurDataURL={BLUR_PLACEHOLDER}
              />
            </div>
          </div>
        </div>
      )}

      {/* TEXT CONTENT */}
      {!title?.hidden && (
        <div className={`bg-012061 p-4 ${title?.customClass || ""}`}>
          <h3 className="text-white font-tamil text-12-tamil-700 text-center">
            {titleValue}
          </h3>
        </div>
      )}
    </article>
  );

  if (slug) {
    return (
      <Link
        href={slug}
        className="block hover:opacity-90 transition-opacity"
      >
        {content}
      </Link>
    );
  }

  return content;
}
